import {
  oneTimeSetup,
  sharedSetup,
  logCustomDatadogAction,
  logDatadogError,
  setDatadogRumContext,
} from "app/scripts/shared_setup"
import { fetchFragment } from "shared/lib/fetch_fragment"
import { runWhenIdle } from "shared/lib/utils"
import { initSentryBrowser } from "app/scripts/sentry_browser_setup"
import { attachNewBadgeForButtons } from "shared/scripts/new_badge_button"
import VanillaFittty from "shared/scripts/vanilla_fittty"
import RubberBandPinchColor from "app/scripts/rubber_band_pinch_color"
import BackButton from "app/scripts/back_button"
import lazyBGImageObserver from "app/scripts/lazy_bg_img_observer"
import SetupUnifiedMobileMenu from "shared/scripts/setup_unified_mobile_menu"
import SetupAccountMenu from "shared/scripts/setup_account_menu"
import { GenericSearchInputSetup } from "app/components/universal_search/generic_search_input"
import { UniversalSearchHeader } from "app/components/universal_search/header"
import SetupClickToCopyButton from "shared/scripts/setup_click_to_copy_button"
import { expireBFCache } from "shared/scripts/back_forward_cache_utils"

function sharedVanillaSetup() {
  oneTimeSetup()
  initSentryBrowser()
  GenericSearchInputSetup()
  UniversalSearchHeader()

  document.addEventListener("DOMContentLoaded", () => {
    sharedSetup()

    const tryProFreeButton = document.getElementById("try-pro-free")
    tryProFreeButton?.addEventListener(
      "click",
      () => {
        logCustomDatadogAction?.("click_try_pro_free")
      },
      { once: true },
    )

    // Fit every [data-fittty] node (an opt-in attribute), not just those under
    // <main> — heros render outside main (e.g. service/connect). VanillaFittty
    // waits for fonts and chunks work across rAFs; first paint still happens first.
    void VanillaFittty()

    runWhenIdle(() => {
      attachNewBadgeForButtons()
      lazyBGImageObserver()
    })
  })

  window.App = window.App || {}
  window.App = Object.assign(window.App, {
    storedFieldPath: (resolveUrl, liveChannelId = "") => {
      if (liveChannelId === "") {
        return `/stored_fields/options?resolve_url=${resolveUrl}`
      } else {
        return `/stored_fields/options?resolve_url=${resolveUrl}&live_channel_id=${liveChannelId}`
      }
    },
  })
  window.App.Comps = {}
  window.App.Scripts = {
    BackButton,
    RubberBandPinchColor,
    SetupUnifiedMobileMenu,
    SetupAccountMenu,
    SetupClickToCopyButton,
    expireBFCache,
  }
  window.App.Utils = {
    logCustomDatadogAction,
    logDatadogError,
    fetchFragment,
  }
}

export { logCustomDatadogAction, setDatadogRumContext, sharedVanillaSetup }
